import { Dc_Card_Sticky } from "@op/sf-op";
import type { StickyCardProps } from "@op/puck-types";
import { LazyIcon } from "@op/icons";
import {
  makeEditorImageUrl,
  makeRendererImageUrl,
  MediaPreview,
  useRender,
} from "@op/utils";
import { useMemo } from "react";

const StickyCard = ({
  medium,
  idx = 0,
  headline,
  icon,
  children,
}: StickyCardProps) => {
  const { context, apiUrl } = useRender();

  const imageUrl = useMemo(() => {
    if (!medium || !medium.uploadId) return "";
    switch (context) {
      case "editor":
        return makeEditorImageUrl(medium.uploadId, apiUrl);
      case "renderer":
        return makeRendererImageUrl(medium.uploadId, apiUrl);
      default:
        return "";
    }
  }, [context, apiUrl, medium]);

  return (
    <Dc_Card_Sticky
      style={{
        breakInside: "avoid-page",
      }}
      isPrint
      changeImagePos={idx % 2 === 0}
      imageSlot={
        medium && (
          <MediaPreview
            cover
            src={imageUrl}
            alt={medium.metadata?.caption || ""}
            mimeType={medium.mimeType}
            width={medium.width}
            height={medium.height}
            loading="eager"
            autoPlay={false}
          />
        )
      }
      icon={icon && <LazyIcon icon={icon} />}
      headline={headline}
      text={children}
    />
  );
};

export default StickyCard;
